import { render, staticRenderFns } from "./Nicklist.vue?vue&type=template&id=38c20874&"
import script from "./Nicklist.vue?vue&type=script&lang=js&"
export * from "./Nicklist.vue?vue&type=script&lang=js&"
import style0 from "./Nicklist.vue?vue&type=style&index=0&id=38c20874&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports